import 'whatwg-fetch';
import { fetchDocs, fetchDoc } from './api';

export default {
  async FETCH_CITIES({ commit }) {
    await fetchDocs('cities').then(cities => commit('SET_CITIES', { cities }));
  },

  async FETCH_ABOUT({ commit }) {
    await fetchDocs('about').then(about => commit('SET_ABOUT', { about }));
  },

  async FETCH_DATACITY({ commit }, city) {
    await fetchDoc(city).then(dataCity => commit('ADD_DATACITY', { dataCity }));
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js